import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
  noindex?: boolean;
  keywords?: string;
}
export function SEO({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  twitterCard = 'summary_large_image',
  noindex = false,
  keywords
}: SEOProps) {
  const siteUrl = 'https://theHIREadvantage.co';
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const fullOgImage = ogImage || `${siteUrl}/og-image.jpg`;
  return <Helmet data-id="element-1053">
      {/* Primary Meta Tags */}
      <title data-id="element-1054">{title}</title>
      <meta name="title" content={title} data-id="element-1055" />
      <meta name="description" content={description} data-id="element-1056" />
      {keywords && <meta name="keywords" content={keywords} data-id="element-1057" />}

      {/* Robots Directive - Explicit indexing control */}
      {noindex ? <meta name="robots" content="noindex,nofollow" data-id="element-1058" /> : <meta name="robots" content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1" data-id="element-1059" />}

      {/* Googlebot specific */}
      {!noindex && <meta name="googlebot" content="index,follow" data-id="element-1060" />}

      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonical} data-id="element-1061" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-1062" />
      <meta property="og:url" content={fullCanonical} data-id="element-1063" />
      <meta property="og:title" content={ogTitle || title} data-id="element-1064" />
      <meta property="og:description" content={ogDescription || description} data-id="element-1065" />
      <meta property="og:image" content={fullOgImage} data-id="element-1066" />
      <meta property="og:site_name" content="The HIRE Advantage" data-id="element-1067" />
      <meta property="og:locale" content="en_US" data-id="element-1068" />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} data-id="element-1069" />
      <meta name="twitter:url" content={fullCanonical} data-id="element-1070" />
      <meta name="twitter:title" content={ogTitle || title} data-id="element-1071" />
      <meta name="twitter:description" content={ogDescription || description} data-id="element-1072" />
      <meta name="twitter:image" content={fullOgImage} data-id="element-1073" />

      {/* Additional SEO tags */}
      <meta name="author" content="The HIRE Advantage" data-id="element-1074" />
      <meta name="publisher" content="The HIRE Advantage" data-id="element-1075" />
      <meta httpEquiv="Content-Language" content="en" data-id="element-1076" />
    </Helmet>;
}